export const NAME_STATUSES = ['published', 'candidate', 'rejected'];
/** The only status the public site serves. */
export const PUBLISHED = 'published';
/** An admin may put candidates on the site too; a rejected row never is. */
export const visibleStatuses = (unreviewed) => unreviewed ? [PUBLISHED, 'candidate'] : [PUBLISHED];
//# sourceMappingURL=NameStatus.js.map